/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：945
 */

var r = require(/* 533 */"../1724/533")
var o = require(/* 1076 */"../1686/1079/1076");
(module.exports = function (e, t) {
  return o[e] || (o[e] = undefined !== t ? t : {})
})("versions", []).push({
  version: "3.17.2",
  mode: r ? "pure" : "global",
  copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
})
